import React, { useContext, useEffect, useState } from 'react'
import SearchTable from 'src/components/searchTable'
import { GlobalContext } from '../../context/GlobalState'
import useAxios from 'axios-hooks'
import { AFFILIATES_ANALYTICS_API } from '../../utils/urls'
import { AppContext } from '../../context/app'
import { Link, useHistory } from 'react-router-dom'
import getSymbolFromCurrency from 'currency-symbol-map'
import { exportToExcel } from 'react-json-to-excel'

const AffiliatesAnalytics = () => {
  const { setLoader } = useContext(AppContext)
  const { userObj } = useContext(GlobalContext)
  const [affiliates, setAffiliates] = useState([])
  const history = useHistory()

  const [{ data: affiliatesAnalyticsDataList, loading: affiliatesAnalyticsDataLoading }] = useAxios(
    {
      url: AFFILIATES_ANALYTICS_API,
      method: 'get',
    },
  )

  useEffect(() => {
    if (affiliatesAnalyticsDataList && affiliatesAnalyticsDataList.success) {
      if (userObj.user_type === 'AFFILIATES_MARKETING') {
        const affiliate = affiliatesAnalyticsDataList.data.filter(
          (item) => item.user_id === userObj._id,
        )[0]
        history.push(`/affiliates/analytics/${affiliate._id}`)
      }
      setAffiliates(affiliatesAnalyticsDataList.data)
    }
  }, [affiliatesAnalyticsDataList])

  useEffect(() => {
    setLoader(affiliatesAnalyticsDataLoading)
  }, [affiliatesAnalyticsDataLoading])

  const tableConfig = [
    {
      header: 'Name',
      dataCell: (info) => <Link to={`/affiliates/analytics/${info._id}`}>{info.name}</Link>,
      width: 15,
    },
    {
      header: 'Email',
      dataCell: (info) => info.email,
      width: 20,
    },
    {
      header: 'Mobile',
      dataCell: (info) => info.mobile,
      width: 14,
    },
    {
      header: 'Status',
      dataCell: (info) => (info.status ? 'Active' : 'In Active'),
      width: 16,
    },
    {
      header: '# Signup ',
      dataCell: (info) => (
        <Link to={`/affiliates/analytics/${info._id}?tab="signup"`}>{info.user_counts}</Link>
      ),
      width: 10,
    },
    {
      header: '# Txn',
      dataCell: (info) => (
        <Link to={`/affiliates/analytics/${info._id}?tab="txn"`}>{info.transactions_count}</Link>
      ),
      width: 13,
    },
    {
      header: 'Txn Amount',
      dataCell: (info) => getSymbolFromCurrency(info.currency) + info.transactions_amount,
      width: 15,
    },
  ]

  const exportData = () => {
    exportToExcel(
      affiliates.map((item) => ({
        'Affiliate Name': item.name,
        'Affiliate Email': item.email,
        'Affiliate Mobile': item.mobile,
        '# Signups': item.user_counts,
        '# Txns': item.transactions_count,
        'Txn Amount': getSymbolFromCurrency(item.currency) + item.transactions_amount,
      })),
      'affiliates',
    )
  }

  return (
    <>
      <h4>{'Affiliates analytics'}</h4>
      <p>{'Marketing affiliates analytics'}</p>
      <SearchTable
        tableCardHeight={65}
        disableButton={false}
        searchTerm={`name`}
        tableContent={affiliates}
        tableConfig={tableConfig}
        createPermission={true}
        type={'affiliates'}
        buttonName={'Export'}
        buttonFunction={exportData}
      />
    </>
  )
}

export default AffiliatesAnalytics
